import { data } from '../../svg/TableEdit/data';
import { makeIcon } from '../makeIcon';

export const TableEdit = makeIcon(data, 'table_edit', 'TableEdit');

export default TableEdit;
